document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll('.statistic-data');
    let animated = false;
    const totalDuration = 3000; // in milliseconds

    function animateCounter(counter) {
        const rawText = counter.textContent.trim();
        const numberMatch = rawText.match(/\d+/);
        if (!numberMatch) return;

        const target = parseInt(numberMatch[0], 10);
        const suffix = rawText.replace(numberMatch[0], ''); // e.g., %, +, etc.

        let current = 0;
        const stepDelay = totalDuration / target;

        function step() {
            counter.textContent = current + suffix;
            if (current < target) {
                current++;
                setTimeout(step, stepDelay);
            }
        }

        step();
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !animated) {
                counters.forEach(counter => animateCounter(counter));
                animated = true;
                observer.disconnect();
            }
        });
    }, {
        threshold: 0.4
    });

    if (counters.length > 0) {
        observer.observe(counters[0].closest('.statistics-section'));
    }
});